import jackiePic from "@/public/images/artists/jackie.png";
import { Artist } from "@/types/types";

export const jackie = {
  id: "156",
  name: "Jackie",
  image: jackiePic,
  description: `Jackie's voice sits comfortably in a robust midrange, with a natural warmth that adds depth to her rock sound. Her tone is focused and powerful, shaping her performances with a distinct intensity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjackie-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Rock", "Blues"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 71,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
